/** 权限对应的菜单 */
let map = {
  "admin:manage:doctor": [{title: '医生列表', path: '/admin/doctor/list', sort: 10}],
  //"admin:manage:apply": [{title: '申请列表', path: '/admin/doctor/apply-list', sort: 1}],
  "admin:manage:article": [{title: '文章管理', path: '/admin/page/list', sort: 20}],
  "admin:manage:recommend": [{title: '推荐管理', path: '/admin/recommend/setting', sort: 30}],
  "admin:manage:chat_server": [{title: '在线客服', path: '/admin/chatServer', sort: 40}],
  "admin:manage:consultation": [{title: '会诊管理', path: '/admin/consultationManage', sort: 50}],
  "admin:manage:lecture": [{title: '讲座管理', path: '/admin/lectureManage', sort: 60}],
  "admin:manage:drug": [{title: '药物管理', path: '/admin/drug/list', sort: 70}],
  "admin:manage:drug:fresh": [{title: '新药管理', path: '/admin/drug/fresh', sort: 70}],
  "admin:manage:indication": [{title: '病症管理', path: '/admin/indication/list', sort: 80}],
  "admin:manage:area": [{title: '地区管理', path: '/admin/city/list', sort: 90}],
  "admin:manage:user": [{title: '用户管理', path: '/admin/user/list', sort: 12}],
  "admin:manage:exam": [{title: '测试管理', path: '/admin/exam/list', sort: 110}],
  "admin:manage:event": [{title: '操作日志', path: '/admin/event/list', sort: 120}],
  "admin:manage:dict": [
    {title: '字典管理', path: '/admin/dict/list', sort: 130},
    {title: '欢迎管理', path: '/admin/welcomePage/doctorQuotationList', sort: 172}
  ],
  "admin:manage:auth": [
    {title: '角色管理', path: '/admin/role/roleManage', sort: 140},
    {title: '权限管理', path: '/admin/auth/authManage', sort: 150}],
  "admin:manage:index:banner": [{title: '首页管理', path: '/admin/index/banner', sort: 160}],
  "admin:manage:feedback": [{title: '反馈管理', path: '/admin/feedback/list', sort: 170}],
  "admin:manage:article:system": [{title: '系统文章', path: '/admin/systemArticle/list', sort: 171}],
};


let none_map = [
  {title: '预约管理', path: '/admin/appoint/list', sort: 9},
  {title: '消息管理', path: '/admin/message/template/list', sort: 180},
  {title: '发送邮件', path: '/admin/sendEmail/list', sort: 181},
  // TODO 此部分权限管理
  {title: '申请列表', path: '/admin/doctor/apply-list', sort: 11},
  {title: '结账列表', path: '/admin/settlementBillList', sort: 13},
  {title: '退款管理', path: '/admin/refundBillList', sort: 14},
  {title: '企业管理', path: '/admin/corpList', sort: 15},
];


/**
 * 根据权限返回对应的菜单
 * @param permissions
 * @returns [{},{}...]
 */
function getMenuByPermissions(permissions) {
  if (!Array.isArray(permissions)) {
    throw new Error("permissions error: not a array type");
  }
  let permissionLength = permissions.length;
  let menus = [];
  for (let i = 0; i < permissionLength; i++) {
    let key = $.trim(permissions[i]);
    let menu = map[key];
    if (menu) {
      menus.push(...menu);
    }
  }
  // none-map处理
  menus.push(...none_map);
  // 重新调整顺序
  menus.sort((a, b) => a.sort - b.sort);
  return menus;
}

export default {
  getMenuByPermissions
}
